import { useTheme } from '@mui/material';
import {
  Club,
  Sparkle,
  Star,
  Bank,
  Buildings,
  Storefront,
  BookBookmark,
  Books,
  Globe,
  Megaphone,
  Folders,
  Atom,
  RocketLaunch,
  File,
  CalendarCheck,
  Confetti,
  Gift,
  Handshake,
  Smiley,
  Lightbulb,
  CaretRight,
  Files,
  CheckFat,
  Plant,
  HeartHalf,
  BookOpenText,
  Certificate,
  IconProps,
} from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import {
  ListItemStyled,
  ListItemButtonStyled,
  ListItemIconDefaultStyled,
  ListItemTextStyled,
} from './CategoryItemStyled';
import { defaultTheme } from 'theSource/theme';

export interface IconClassProps {
  iconClass: string;
}

export const components: {
  [key: string]: React.ForwardRefExoticComponent<
    IconProps & React.RefAttributes<SVGSVGElement>
  >;
} = {
  Club,
  Sparkle,
  Star,
  Bank,
  Buildings,
  Storefront,
  BookBookmark,
  Books,
  Globe,
  Megaphone,
  Folders,
  Atom,
  RocketLaunch,
  File,
  CalendarCheck,
  Confetti,
  Gift,
  Handshake,
  Smiley,
  Lightbulb,
  Files,
  CheckFat,
  Plant,
  HeartHalf,
  BookOpenText,
  Certificate,
};

export function SpecificIcon(props: IconClassProps) {
  const SpecificIcon = components[props.iconClass];
  if (SpecificIcon) {
    return (
      <SpecificIcon
        size={32}
        color={defaultTheme.palette.primary.main}
        weight="duotone"
      />
    );
  }
  return (
    <Star
      size={32}
      color={defaultTheme.palette.primary.main}
      weight="duotone"
    />
  );
}

interface CategoryItemProps {
  title: string;
  locked: boolean;
  lookupCode: string;
  url?: string;
  icon: string;
}

export const CategoryItem = ({
  title,
  locked,
  lookupCode,
  url,
  icon,
}: CategoryItemProps) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleClick = () => {
    locked
      ? navigate('documents')
      : url
      ? window.open(url, '_blank')
      : navigate(lookupCode);
  };

  return (
    <ListItemStyled data-testid="my-company-list-item">
      <ListItemButtonStyled onClick={() => handleClick()}>
        <SpecificIcon iconClass={icon} />
        <ListItemTextStyled
          primaryTypographyProps={{
            variant: 'body2',
          }}
          primary={title}
        />
        <ListItemIconDefaultStyled>
          <CaretRight
            size={20}
            weight="bold"
            color={theme.palette.primary.main}
          />
        </ListItemIconDefaultStyled>
      </ListItemButtonStyled>
    </ListItemStyled>
  );
};
